import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { RootState } from '../../store';

export interface JobCountState {
  jobCount: number | null;
  updateDate: string | null;
  searchJobTypeLList: JobCountDetailResponse[];
  areaList: JobCountDetailResponse[];
  industryLList: JobCountDetailResponse[];
}

export interface JobCountSliceState {
  jobCount: ReturnType<typeof jobCountReducer>;
}

export const jobCountInitialState: JobCountState = {
  jobCount: null,
  updateDate: null,
  searchJobTypeLList: [],
  areaList: [],
  industryLList: [],
};

const jobCountSlice = createSlice({
  name: 'jobCount',
  initialState: jobCountInitialState,
  reducers: {
    setJobCount: (state, action: PayloadAction<number>) => {
      state.jobCount = action.payload;
    },
    setUpdateDate: (state, action: PayloadAction<string>) => {
      state.updateDate = action.payload;
    },
    setSearchJobTypeLList: (
      state,
      action: PayloadAction<JobCountDetailResponse[]>
    ) => {
      state.searchJobTypeLList = action.payload;
    },
    setAreaList: (state, action: PayloadAction<JobCountDetailResponse[]>) => {
      state.areaList = action.payload;
    },
    setIndustryLList: (
      state,
      action: PayloadAction<JobCountDetailResponse[]>
    ) => {
      state.industryLList = action.payload;
    },
  },
});

// Create Action
export const {
  setJobCount,
  setUpdateDate,
  setSearchJobTypeLList,
  setAreaList,
  setIndustryLList,
} = jobCountSlice.actions;

// Reducer
export const jobCountReducer = jobCountSlice.reducer;

// Selector
export const jobCountSelector = (state: RootState) => state.jobCount;
